@if (dataLoading()) {<app-progress></app-progress>}

<div class="page-content">
    <div class="container-fluid">

        <!-- ── Page Header ──────────────────────────────────────────────── -->
        <div class="row mb-3">
            <div class="col-12">
                <div class="d-flex align-items-center justify-content-between bg-white p-3 rounded shadow-sm">
                    <div>
                        <h4 class="mb-1 text-primary">{{ action().MenuTitle }}</h4>
                        <p class="text-muted mb-0 small">{{ action().ParentMenuTitle }} / {{ action().MenuTitle }}</p>
                    </div>
                    <button mat-stroked-button color="primary" routerLink="/admin/admin-dashboard">
                        <i class="bx bx-home-alt me-1"></i> Dashboard
                    </button>
                </div>
            </div>
        </div>

        <!-- ════════════════════════════════════════════════════════════════
         SECTION 1 — Entry Form (Hotel Selection + Rates)
    ════════════════════════════════════════════════════════════════ -->
        <form #formSpecialInclusion="ngForm">
            <div class="row">

                <!-- ── Left: Hotel Selection ─────────────────────────────────── -->
                <div class="col-xl-4">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-transparent border-bottom">
                            <h5 class="card-title mb-0">
                                <i class="bx bx-buildings me-2 text-primary"></i>Hotel Selection
                            </h5>
                        </div>
                        <div class="card-body px-3 py-3">
                            <div class="row g-3">

                                <!-- Destination -->
                                <div class="col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Destination</mat-label>
                                        <mat-select name="SelectedDestinationId" [(ngModel)]="SelectedDestinationId"
                                            (ngModelChange)="onFormDestinationChange()" required>
                                            @for (dest of DestinationList(); track dest.DestinationId) {
                                            <mat-option [value]="dest.DestinationId">{{ dest.DestinationName
                                                }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- No location message -->
                                    @if (formLocationMsg) {
                                    <div class="alert alert-warning py-2 px-3 mb-0 d-flex align-items-center gap-2"
                                        style="font-size:13px;">
                                        <i class="bx bx-info-circle"></i> {{ formLocationMsg }}
                                    </div>
                                    }
                                </div>

                                <!-- Location -->
                                <!-- @if (FormLocationList().length > 0) { -->
                                <div class="col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Location</mat-label>
                                        <mat-select name="SelectedLocationId" [(ngModel)]="SelectedLocationId"
                                            (ngModelChange)="onFormLocationChange()" required>
                                            @for (loc of FormLocationList(); track loc.LocationId) {
                                            <mat-option [value]="loc.LocationId">{{ loc.LocationName }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- No hotel message -->
                                    @if (formHotelMsg) {
                                    <div class="alert alert-warning py-2 px-3 mb-0 d-flex align-items-center gap-2"
                                        style="font-size:13px;">
                                        <i class="bx bx-info-circle"></i> {{ formHotelMsg }}
                                    </div>
                                    }
                                </div>
                                <!-- } -->

                                <!-- Hotel -->
                                <!-- @if (FormFilteredHotelList().length > 0) { -->
                                <div class="col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Select Hotel</mat-label>
                                        <mat-select name="HotelId" [(ngModel)]="SpecialInclusion.HotelId"
                                            (ngModelChange)="onHotelChange()" required>
                                            @for (hotel of FormFilteredHotelList(); track hotel.HotelId) {
                                            <mat-option [value]="hotel.HotelId">{{ hotel.HotelName }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <!-- } -->

                                <!-- Hotel Category badge -->
                                @if (SpecialInclusion.HotelCategoryName) {
                                <div class="col-12">
                                    <div class="alert alert-info py-2 mb-0 d-flex align-items-center gap-2">
                                        <i class="bx bx-star"></i>
                                        <strong>{{ SpecialInclusion.HotelCategoryName }}</strong>
                                    </div>
                                </div>
                                }

                            </div>
                        </div>
                    </div>
                </div>

                <!-- ── Right: Rate Entry ──────────────────────────────────────── -->
<div class="col-xl-8">
  <div class="row g-3">

    @if (SpecialInclusion.HotelId) {

      @for (type of SpecialInclusionTypeList(); track type.SpecialInclusionTypeId) {
        <div class="col-md-6 col-lg-4">

          <div class="card border shadow-sm h-100">
            <div class="card-body p-3">

              <!-- Title -->
              <h6 class="text-truncate text-dark mb-3 fw-semibold"
                  style="font-size: 13px; letter-spacing: 0.4px;">
                {{ type.SpecialInclusionTypeName }}
              </h6>

              <!-- Rate -->
              <div class="input-group mb-3">
                <span class="input-group-text">₹</span>
                <input type="number"
                       class="form-control"
                       placeholder="Enter rate"
                       [(ngModel)]="getRateInput(type.SpecialInclusionTypeId).Rate"
                       [name]="'Rate_' + type.SpecialInclusionTypeId">
              </div>

              <!-- Status -->
              <select class="form-select form-select-sm"
                      [(ngModel)]="getRateInput(type.SpecialInclusionTypeId).Status"
                      [name]="'Status_' + type.SpecialInclusionTypeId">
                @for (status of StatusList; track status.Key) {
                  <option [value]="status.Key">{{ status.Value }}</option>
                }
              </select>

            </div>
          </div>

        </div>
      }

      <!-- Save Button -->
      <!-- <div class="col-12 mt-4 text-end">
        <button mat-raised-button color="primary"
                class="px-5 py-2"
                (click)="saveSpecialInclusions()">
          <i class="bx bx-save me-1"></i>
          Save All Inclusions
        </button>
      </div> -->

      <div class="col-12 mt-4 text-end">
        <button mat-raised-button color="primary" class="px-5 py-2"
        (click)="saveSpecialInclusions()"><i class="bx bx-save me-1"></i> 
        {{ isEditMode ? 'Update' : 'Save'}}    
    </button>
        @if (isEditMode) {
            <button mat-stroked-button color="warn"
                class="px-4 py-2 ms-2" ((click)="cancelEdit()")>
            <i class="bx bx-x me-1"></i></button>
        }
      </div>


    } @else {

      <!-- Empty State -->
      <div class="col-12">
        <div class="card border p-5 text-center text-muted">
          <i class="bx bx-hotel fs-1 mb-3"></i>
          <div>Select a hotel to populate the inclusion types.</div>
        </div>
      </div>

    }

  </div>
</div>

            </div>
        </form>
<br>    
        <!-- ════════════════════════════════════════════════════════════════
         SECTION 2 — Filter + Table Listing
    ════════════════════════════════════════════════════════════════ -->
        <div class="card border-0 shadow-sm mb-4">
            <div class="card-header bg-transparent border-bottom">
                <h5 class="card-title mb-1">
                    <i class="bx bx-filter-alt me-2 mt-2 text-warning"></i>View Special Inclusions
                </h5>
            </div>
            <div class="card-body">

                <!-- ── Filter Row ─────────────────────────────────────────────── -->
                <div class="row g-3 align-items-start mb-3">

                    <!-- Filter Destination -->
                    <div class="col-xl-3 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Destination</mat-label>
                            <mat-select name="FilterDestinationId" [(ngModel)]="FilterDestinationId"
                                (ngModelChange)="onFilterDestinationChange()">
                                <mat-option [value]="0">-- Select Destination --</mat-option>
                                @for (dest of DestinationList(); track dest.DestinationId) {
                                <mat-option [value]="dest.DestinationId">{{ dest.DestinationName }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <!-- No location message for filter -->
                        @if (filterLocationMsg) {
                        <div class="alert alert-warning py-2 px-3 mt-1 d-flex align-items-center gap-2"
                            style="font-size:12px;">
                            <i class="bx bx-info-circle"></i> {{ filterLocationMsg }}
                        </div>
                        }
                    </div>

                    <!-- Filter Location -->
                    <div class="col-xl-3 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Location</mat-label>
                            <mat-select name="FilterLocationId" [(ngModel)]="FilterLocationId"
                                (ngModelChange)="onFilterLocationChange()"
                                [disabled]="FilterLocationList().length === 0 && !filterLocationMsg">
                                <mat-option [value]="0">-- Select Location --</mat-option>
                                @for (loc of FilterLocationList(); track loc.LocationId) {
                                <mat-option [value]="loc.LocationId">{{ loc.LocationName }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <!-- No hotel message for filter -->
                        @if (filterHotelMsg) {
                        <div class="alert alert-warning py-2 px-3 mt-1 d-flex align-items-center gap-2"
                            style="font-size:12px;">
                            <i class="bx bx-info-circle"></i> {{ filterHotelMsg }}
                        </div>
                        }
                    </div>

                    <!-- Filter Hotel -->
                    <div class="col-xl-3 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Hotel</mat-label>
                            <mat-select name="FilterHotelId" [(ngModel)]="FilterHotelId"
                                (ngModelChange)="onFilterHotelChange()"
                                [disabled]="FilterHotelList().length === 0 && !filterHotelMsg">
                                <mat-option [value]="0">-- Select Hotel --</mat-option>
                                @for (hotel of FilterHotelList(); track hotel.HotelId) {
                                <mat-option [value]="hotel.HotelId">{{ hotel.HotelName }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                </div>

                <!-- ── Table ──────────────────────────────────────────────────── -->

                <!-- Loading spinner for filter -->
                @if (filterDataLoading()) {
                <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="text-muted mt-2 mb-0 small">Loading data...</p>
                </div>
                }

                <!-- No hotel selected yet -->
                @if (!filterDataLoading() && !FilterHotelId) {
                <div class="text-center py-5 text-muted">
                    <i class="bx bx-filter fs-1 d-block mb-2 opacity-25"></i>
                    <p class="mb-0">Select destination, location and hotel to view records.</p>
                </div>
                }

                <!-- No data found -->
                @if (!filterDataLoading() && FilterHotelId && SpecialInclusionListData().length === 0) {
                <div class="text-center py-5 text-muted">
                    <i class="bx bx-data fs-1 d-block mb-2 opacity-25"></i>
                    <p class="mb-1 fw-semibold">No Data Found</p>
                    <p class="mb-0 small">No special inclusions have been added for this hotel yet.</p>
                </div>
                }

                <!-- Data table -->
                @if (!filterDataLoading() && FilterHotelId && SpecialInclusionListData().length > 0) {
                <div class="table-responsive">
                    <table class="table table-bordered table-hover align-middle mb-0" style="font-size:13.5px;">
                        <thead class="table-light">
                            <tr>
                                <th style="width:50px">#</th>
                                <th>Special Inclusion Type</th>
                                <th>Rate (₹)</th>
                                <th style="text-align: center;">Action</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (
                            row of SpecialInclusionListData()
                            | paginate: { itemsPerPage: itemPerPage, currentPage: p };
                            track row.SpecialInclusionId;
                            let i = $index
                            ) {
                            <tr>
                                <td class="text-muted fw-semibold">
                                    {{ (p - 1) * itemPerPage + i + 1 }}
                                </td>
                                <td class="fw-semibold">{{ row.SpecialInclusionTypeName }}</td>
                                <td>
                                    <span class="fw-semibold text-success">₹ {{ row.Rate | number: '1.2-2' }}</span>
                                </td>
                                <td class="text-center">
                                    <button mat-icon-button color="primary" (click)="editRecord(row)" matTooltip="Edit">
                                    <i class="bx bx-edit-alt"></i>
                                    </button>
                                    <button mat-icon-button color="warn" (click)="deleteRecord(row)" matTootip="Delete">
                                        <i class="bx bx-trash"></i>
                                    </button>
                                </td>
                                <td>
                                    @if (row.Status === 1) {
                                    <span
                                        class="badge rounded-pill bg-success-subtle text-success border border-success-subtle px-2">
                                        Active
                                    </span>
                                    } @else {
                                    <span
                                        class="badge rounded-pill bg-danger-subtle text-danger border border-danger-subtle px-2">
                                        Inactive
                                    </span>
                                    }
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <!-- Pagination -->
                <div class="d-flex justify-content-between align-items-center mt-3">
                    <small class="text-muted">
                        Showing {{ (p - 1) * itemPerPage + 1 }} –
                        {{ p * itemPerPage > SpecialInclusionListData().length ? SpecialInclusionListData().length : p *
                        itemPerPage }}
                        of {{ SpecialInclusionListData().length }} records
                    </small>
                    <pagination-controls (pageChange)="onTableDataChange($event)" [maxSize]="5" previousLabel="Prev"
                        nextLabel="Next">
                    </pagination-controls>
                </div>
                }

            </div>
        </div>

    </div>
</div>